import axios from 'axios';
import FormData from 'form-data';
const BASE_URL = process.env.REACT_APP_BACKEND_URL;


export async function sendToServer(
  fileName,
  contactBlob,
  companyBlob,
  contactBlob2,
  projectBlob,
  toggleModal,
  setLoading,
  hubspot_api_key,
  dealStage,
  presetName = null,
  pipeline,
    // longitude,
  // latitude
) {
  console.log("pipeline in send to server [2]", pipeline);
  let form = new FormData();
  form.append('files', contactBlob, 'Construct Connect Contacts Main.csv');
  form.append('files', companyBlob, 'Construct Connect Company.csv');
  form.append('files', contactBlob2, 'Construct Connect Contacts.csv');
  form.append('files', projectBlob, 'Construct Connect Projects.csv');
  form.append('filename', fileName);
  form.append('hubspot_api_key', hubspot_api_key);
  form.append('deal_stage', dealStage);
  if (presetName) {
    form.append('presetName', presetName);
  }
  form.append('pipeline', pipeline);
    // form.append('longitude', longitude);
  // form.append('latitude', latitude);
  if (hubspot_api_key !== '') {
    try {
      setLoading(true);

      // ✅ Log all the data you're sending
      console.log("🟡 Preparing to send to server:");
      console.log("📁 Filename:", fileName);
      console.log("🔑 Hubspot Key:", hubspot_api_key);
      console.log("📍 Deal Stage:", dealStage);

      const blobToText = async (blob) => {
        const text = await blob.text();
        console.log(text);
      };

      console.log("📦 Contact Blob:");
      await blobToText(contactBlob);

      console.log("🏢 Company Blob:");
      await blobToText(companyBlob);

      console.log("📦 Secondary Contact Blob:");
      await blobToText(contactBlob2);

      console.log("📁 Project Blob:");
      await blobToText(projectBlob);

      // Get the auth token from localStorage
      const token = localStorage.getItem('authToken');
      
      const res = await axios.post(`${BASE_URL}/upload/contacts`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (res.status === 200) {
        console.log(`✅ Message from server: ${res.data.message}`);
        return {
          message: res.data.message,
          successCount: res.data.successCount,
          updatedCount: res.data.updatedCount,
          fileName: fileName,
          presetName: presetName,
          pipeline: pipeline,
        };
      } else {
        console.log("❌ Server responded with an unexpected status.");
        toggleModal("Failed");
        return { message: "Failed" };
      }
      

    } catch (error) {
      console.error("🚨 Error sending contact and company data to backend server:", error);
      console.error("🚨 Backend response body:", error.response?.status, error.response?.data);
    }
  } else {
    console.warn("❌ There's no hubspot api key!");
  }
}


export async function sendToServerCompany(fileName, contactBlob, toggleModal, setLoading, hubspot_api_key) {
  let form  = new FormData();
  form.append('files', contactBlob, 'Construct Connect Company Contacts.csv');
  form.append('filename', fileName);
  form.append('hubspot_api_key', hubspot_api_key); 

  if(hubspot_api_key){
    try {
      setLoading(true);
      // Get the auth token from localStorage
      const token = localStorage.getItem('authToken');
      
      const res = await axios.post(`${BASE_URL}/upload/companies`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`,
        }
      });

      if(res.status === 200){
        console.log(`Message from server: ${res.data.message}`);
      }else{
        toggleModal("Failed");
      }
    } catch (error) {
      console.error(`Error sending contact and company data to backend. Error: ${error?.response?.data || error.message}`);
      toggleModal("Failed");
    } finally {
      setLoading(false);
    }
  } else {
    console.warn("No HubSpot API key provided!");
  }
}



